import service from '../api/template.service';

//constants
const dataDetail= {
    details: [],
    createDetail: '',
    errorDetail: '',
    deleteDetail: ''
}

//types
const DETAIL_LIST = 'DETAIL_LIST'
const DETAIL_UPDATE = 'DETAIL_UPDATE'
const DETAIL_DELETE = 'DETAIL_DELETE'
const DETAIL_ERROR = 'DETAIL_ERROR'

export default function detailReducer(state = dataDetail, action) {
    switch (action.type) {
        case DETAIL_LIST:
            return { ...state, details: action.payload };
        case DETAIL_UPDATE:
            return { ...state, createDetail: action.payload };
        case DETAIL_DELETE:
            return { ...state, deleteDetail: action.payload };
        case DETAIL_ERROR:
            return { ...state, errorDetail: action.payload };
        default:
            return { ...state };
    }
}

export const getDetail = (template,username) => async (dispatch) => {
    const response = await service.getDetail(username,template).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.code !== undefined) {
        dispatch({
            type: DETAIL_ERROR,
            payload: response
        });
        dispatch({
            type: DETAIL_LIST,
            payload: []
        });

    } else {
        dispatch({
            type: DETAIL_ERROR,
            payload: ''
        });
        dispatch({
            type: DETAIL_LIST,
            payload: response
        });
    }
}

export const createDetail = (detail, username) => async (dispatch) => {
    const response = await service.addDetail(detail, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: DETAIL_ERROR,
            payload: response
        });
        dispatch({
            type: DETAIL_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: DETAIL_ERROR,
            payload: ''
        });
        dispatch({
            type: DETAIL_UPDATE,
            payload: response
        });
    }
}
export const updateDetailData= (detail, username) => async (dispatch) => {
    const response = await service.updateDetail(detail, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: DETAIL_ERROR,
            payload: response
        });
        dispatch({
            type: DETAIL_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: DETAIL_ERROR,
            payload: ''
        });
        dispatch({
            type: DETAIL_UPDATE,
            payload: response
        });
    }
}

export const deleteDetail= (lsData, username) => async (dispatch) => {
    const response = await service.deleteDetail(lsData, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });
    if (response.error !== undefined) {
        dispatch({
            type: DETAIL_ERROR,
            payload: response
        });
        dispatch({
            type: DETAIL_DELETE,
            payload: []
        });
    } else {
        dispatch({
            type: DETAIL_ERROR,
            payload: ''
        });
        dispatch({
            type: DETAIL_DELETE,
            payload: response
        });
    }
}